<template>
  <Modal
    ref="modal"
    title="New Sms Template"
    action="Save"
    action-color="indigo"
    @close-modal="handleCancelSettings"
    @handle-action="createSmsTemplate"
  >
    <TextInput
      label="Template Name"
      placeholder="Enter a name for this Sms template"
      :model-value="sms.templateName"
      @update:model-value="sms.templateName = $event"
    />
    <TextareaMergeTagInput
      ref="contentInput"
      label="Content"
      placeholder="Greetings from earth!"
      :model-value="sms.body"
      @update:model-value="val => (sms.body = val)"
    />
    <MergeTagSelect class="mt-4" @selected-tag="tag => $refs.contentInput.insertMergeTagAtCursor(tag)" />
  </Modal>
</template>

<script>
import Modal from '../../shared/Modal.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import MergeTagSelect from '@/components/shared/merge_tag/MergeTagSelect/index.vue';
import { hFetch } from '@/api/hFetch';
import TextareaMergeTagInput from '@/components/shared/merge_tag/textarea_input/TextareaMergeTagInput.vue';

export default {
  components: {
    Modal,
    MergeTagSelect,
    TextareaMergeTagInput,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      sms: {
        templateName: '',
        body: '',
      },
    };
  },
  methods: {
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
    async createSmsTemplate() {
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      const response = await hFetch({
        url: '/api/sms_templates',
        method: 'POST',
        payload: {
          name: this.sms.templateName,
          body: this.sms.body,
        },
      });

      this.loadingSpinnerStore.hideLocalLoadingSpinner();
      if (response.status != 'error') {
        toast.success('SMS template saved', {
          action: { label: 'Dismiss' },
          description: 'Your SMS Template was successfully saved.  Use the button below to dismiss this alert.',
        });
        this.$emit('handleSaveSettings');
      } else {
        toast.error('SMS template save error', {
          action: { label: 'Dismiss' },
          description: response.message,
        });
      }
    },
  },
};
</script>
